<template lang="html">
  <f7-page>
    <div class="navbar">
      <div class="navbar-inner">
        <div class="left">
          <a href="#"
            @click="$f7router.back()">
            <f7-icon f7="chevron_left" />
          </a>
        </div>
        <div class="title">Itinéraires</div>
        <div class="right">
          <a href="/tracks/new">
            <f7-icon f7="add" />
          </a>
        </div>
      </div>
    </div>
    <TracksList />
  </f7-page>
</template>

<script>
import TracksList from '@/components/modules/AtlasTracks/TracksList'
export default {
  name: 'TracksPage',
  components: {
    TracksList
  },
  methods: {
    goBack () {

    }
  }
}
</script>

<style lang="css">
</style>
